import { FC } from "react";

import styles from "./tileSidebarMenuItem.module.scss";

type TTileSidebarMenuItem = {
    id?: string,
    text: string,
    imageUrl: string,
    onClickHandler?: () => void,
    extraClassNames?: string[],
    children?: JSX.Element | JSX.Element[],
    handleRightSidebarHoveringCollapse?: boolean,
    isOnRightSidebarHoverCollapsed: boolean,
    setIsOnRightSidebarHoverCollapsed: (newIsOnRightSidebarHoverCollapsedValue: boolean) => void,
    isCollapsedSidebarRight: boolean,
    isNewFeature?: boolean,
};

export const TileSidebarMenuItem: FC<TTileSidebarMenuItem> = ({ id, text, imageUrl, onClickHandler, extraClassNames, handleRightSidebarHoveringCollapse, isOnRightSidebarHoverCollapsed, setIsOnRightSidebarHoverCollapsed, isCollapsedSidebarRight, children, isNewFeature }: TTileSidebarMenuItem) => {
    const getClassName = (): string => {
        const classNameList = [styles.menuItem];
        if(extraClassNames) {
            classNameList.push(...extraClassNames);
        }
        return classNameList.join(" ");
    };

    const handleOnClick = (): void => {
        if(onClickHandler) onClickHandler();
        if(handleRightSidebarHoveringCollapse && isCollapsedSidebarRight) {
            setIsOnRightSidebarHoverCollapsed(!isOnRightSidebarHoverCollapsed);
        }
    };

    return (
        <div style={{position: "relative"}} > 
            <button id={id} className={getClassName()} onClick={handleOnClick}>
                <img src={imageUrl} alt={text} />
                <span>{text}</span>
                {isNewFeature ?
                    <>
                        {!isCollapsedSidebarRight || isOnRightSidebarHoverCollapsed ? 
                            <div className={styles.newFeatureTextHighlight}>
                                <span>New</span>
                            </div>
                            :
                            <div className={styles.newFeatureDotHighlight}></div>
                        }
                    </>
                    :
                    <></>
                }
            </button>
            {children}
        </div>
    );
};